import { render, staticRenderFns } from "./CourseTransfer.vue?vue&type=template&id=484ccf6e&scoped=true"
import script from "./CourseTransfer.vue?vue&type=script&lang=js"
export * from "./CourseTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484ccf6e",
  null
  
)

export default component.exports